import { useId } from "react";

import { Checkbox } from "@/components/ui/Checkbox";
import { usePatchCart } from "@/customer/cart/hooks";
import type { Cart } from "@/customer/cart/types";

// FR-7 apparent-agent consent — single checkbox plus the exact legal
// label. Toggling auto-saves; we don't gate on a separate "Save"
// click because this is a single binary that mirrors the cart row.
export function ApparentAgentSection({
  cart,
  onAdvance
}: {
  cart: Cart;
  onAdvance(): void;
}): JSX.Element {
  const id = useId();
  const patch = usePatchCart();
  const checked = cart.payload.apparent_agent_consent === true;

  function handleChange(next: boolean | "indeterminate"): void {
    patch.mutate(
      { apparent_agent_consent: next === true },
      {
        onSuccess: () => {
          if (next === true) onAdvance();
        }
      }
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-start gap-3">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={handleChange}
          disabled={patch.isPending}
          className="mt-0.5"
        />
        <label htmlFor={id} className="cursor-pointer text-sm text-brand-black">
          I authorize JDR to leave the equipment at the site address without
          a signature if no one is present.
        </label>
      </div>
      <p className="ml-7 text-xs text-zinc-500">
        If you check this box, you&rsquo;ll be asked to type your initials in
        a dedicated field on the rental agreement to confirm this
        authorization.
      </p>
    </div>
  );
}
